import { render } from "./EvaluationHistoryDetail.vue?vue&type=template&id=77c9031e"
import script from "./EvaluationHistoryDetail.vue?vue&type=script&lang=js"
export * from "./EvaluationHistoryDetail.vue?vue&type=script&lang=js"

import "./EvaluationHistoryDetail.vue?vue&type=style&index=0&id=77c9031e&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__